$(document).ready(function() {
  
  $('.qty_random').hide();
  $('.product-variant-picker-block .variant-input').click(function() {
    // console.log( $(this) );
    if($(this).hasClass('soldout')) {
      $('.qty_random').css('display','none');
    } else {
      $('.qty_random').css('display','block');
    }
    var selectedvarid = $(this).attr('data-varid'); 
    //console.log('selectedvarid--',selectedvarid);
    var leftValue = onlyleft[selectedvarid];
    //console.log('leftValue--',leftValue);
    var text = window.theme.strings.stock_only + leftValue + window.theme.strings.stock_units_left;
    if(leftValue != '') {
      $('.qty_random').text(text);
    } else {
      $('.qty_random').text('');
      $('.qty_random').hide();
    }
  });

  if($('.product-variant-picker-block .flex-wrap.items-center:first-child').hasClass('soldout')){
    $('.qty_random').css('display','none');
  } else {
    $('.qty_random').css('display','block');
  }
  
});